"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FosAuthorizer = void 0;
var tslib_1 = require("tslib");
/* eslint-disable import/prefer-default-export */
/* eslint-disable @typescript-eslint/no-unused-expressions */
var okta_auth_js_1 = require("@okta/okta-auth-js");
var okta_signin_widget_1 = (0, tslib_1.__importDefault)(require("@okta/okta-signin-widget"));
var cache_1 = require("../cache");
var logo_svg_1 = (0, tslib_1.__importDefault)(require("../assets/logo.svg"));
/*
 * Singleton for Authentication
 */
var FosAuth = /** @class */ (function () {
    function FosAuth() {
        if (FosAuth.instance === null) {
            FosAuth.instance = this;
        }
        this.getAuthorizationToken = this.getAuthorizationToken.bind(this);
        this.getUserInfo = this.getUserInfo.bind(this);
        this.signOut = this.signOut.bind(this);
        return FosAuth.instance;
    }
    FosAuth.prototype.setup = function (ntConfig) {
        this.ntConfig = ntConfig;
        var oktaConfig = this.ntConfig.Okta;
        this.oktaAuthConfig = oktaConfig;
    };
    /*
     * intended to only be called once within entire FOS lifecycle in NTConfigContext
     */
    FosAuth.prototype.init = function (ntConfig) {
        this.setup(ntConfig);
        this.initOkta();
    };
    /**
     * New entry method that supports single-spa. The Okta client is pre-initialized at the [root level](https://gitlab.com/ntet/front-office-solutions/shared/fos-root-config/-/blob/main/src/root-config.ts?ref_type=heads#L27)
     * and passed to the individual MFEs
     * @param oktaAuth Pre-initialized OktaAuth instance.
     */
    FosAuth.prototype.use = function (ntConfig, oktaAuth) {
        this.setup(ntConfig);
        if (!oktaAuth) {
            throw new Error('OktaAuth is not pre-initialized. You should "init" instead');
        }
        this.oktaAuth = oktaAuth;
        this.initOktaWidget();
    };
    /**
     * Legacy entry method. Use for apps still using the custom FOS MicroFE implementation
     */
    FosAuth.prototype.initOkta = function () {
        if (!this.oktaAuthConfig) {
            throw new Error('Error initializing FOS Okta SDK');
        }
        this.oktaAuth = new okta_auth_js_1.OktaAuth(this.oktaAuthConfig);
        this.initOktaWidget();
    };
    FosAuth.prototype.initOktaWidget = function () {
        if (!this.oktaAuthConfig) {
            throw new Error('Error initializing FOS Okta Widget');
        }
        var _a = this.oktaAuthConfig, baseUrl = _a.baseUrl, issuer = _a.issuer, clientId = _a.clientId, redirectUri = _a.redirectUri, scopes = _a.scopes;
        this.oktaWidgetConfig = {
            baseUrl: baseUrl,
            clientId: clientId,
            redirectUri: redirectUri,
            authParams: {
                issuer: issuer,
                scopes: scopes,
            },
            logo: logo_svg_1.default,
            language: 'en',
            i18n: {
                en: {
                    'primaryauth.title': 'Sign In',
                },
            },
            features: {
                idpDiscovery: true,
            },
            idpDiscovery: {
                requestContext: redirectUri,
            },
        };
        this.oktaWidget = new okta_signin_widget_1.default(this.oktaWidgetConfig);
    };
    FosAuth.prototype.getAuthorizationToken = function () {
        var _a;
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            var err_1;
            return (0, tslib_1.__generator)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.oktaAuth)
                            return [2 /*return*/, undefined];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.oktaAuth.tokenManager.getTokens()];
                    case 2: return [2 /*return*/, (_a = (_b.sent()).accessToken) === null || _a === void 0 ? void 0 : _a.accessToken];
                    case 3:
                        err_1 = _b.sent();
                        // eslint-disable-next-line no-console
                        console.error('FosAuthorizer error obtaining token');
                        return [2 /*return*/, undefined];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FosAuth.prototype.getUserInfo = function () {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            return (0, tslib_1.__generator)(this, function (_a) {
                if (!this.oktaAuth)
                    return [2 /*return*/, null];
                return [2 /*return*/, this.oktaAuth.getUser()];
            });
        });
    };
    FosAuth.prototype.signOut = function () {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            var err_2;
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.oktaAuth)
                            return [2 /*return*/, null];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.oktaAuth.signOut()];
                    case 2:
                        _a.sent();
                        localStorage.clear();
                        cache_1.fosCache.clear();
                        return [2 /*return*/, true];
                    case 3:
                        err_2 = _a.sent();
                        // eslint-disable-next-line no-console
                        console.error('signout error: ', err_2);
                        return [2 /*return*/, false];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FosAuth.instance = null;
    return FosAuth;
}());
var FosAuthorizer = new FosAuth();
exports.FosAuthorizer = FosAuthorizer;
